import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';

export const layoutRoutes: Array<RouteRecordRaw> = [
  {
    path: 'index',
    name: 'index',
    meta: {
      title: 'index',
    },
    component: () => import('@/pages/index.vue'),
  },
];

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/login',
    // 需要layout的页面
    children: layoutRoutes,
  },
  // 不需要layout的页面
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'login',
    },
    component: () => import('@/pages/login/index.vue'),
  },
  {
    path: '/realTimeData',
    name: 'realTimeData',
    meta: {
      title: 'realTimeData',
    },
    component: () => import('@/pages/realTimeData/index.vue'),
  },
  {
    path: '/historyData',
    name: 'historyData',
    meta: {
      title: 'historyData',
    },
    component: () => import('@/pages/historyData/index.vue'),
  },
  {
    path: '/orderData',
    name: 'orderData',
    meta: {
      title: 'orderData',
    },
    component: () => import('@/pages/orderData/index.vue'),
  },
  {
    path: '/foodMgData',
    name: 'foodMgData',
    meta: {
      title: 'foodMgData',
    },
    component: () => import('@/pages/foodMgData/index.vue'),
  },
  // 替代vue2中的'*'通配符路径
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

const router = createRouter({
  history: createWebHashHistory(), // history 模式则使用 createWebHistory()
  routes,
});
export default router;
